/** Centralized map of LI.FI documentation URLs used by DocsLink components across the playground. */
export const docsLinks = {
  overview: 'https://docs.li.fi/widget/overview',
  theme: 'https://docs.li.fi/widget/customize-widget#theme',
  mode: 'https://docs.li.fi/widget/select-widget-layout#mode',
  variant: 'https://docs.li.fi/widget/select-widget-layout#variant',
  height: 'https://docs.li.fi/widget/select-widget-layout#height',
  configure: 'https://docs.li.fi/widget/configure-widget',
  events: 'https://docs.li.fi/widget/widget-events',
  walletManagement: 'https://docs.li.fi/widget/wallet-management',
} as const
